<script lang="ts">
    import { tooltip } from "../../../helper"
    import { login, carts, newNotification } from "../../../store"
    import { updateCart, createCart, getOperation } from "../../../api"
    import { mdiPlusCircleOutline } from "@mdi/js"
    import { createEventDispatcher } from "svelte"
    import Icon from "../../widgets/Icon.svelte"
    import { _ } from "svelte-i18n"
    import Modal from "../../widgets/Modal.svelte"
    import Checkbox from "../../widgets/Checkbox.svelte"
    import EditField from "../../widgets/fields/EditField.svelte"
    import Radiobutton from "../../widgets/Radiobutton.svelte"
    import { getOriginOffer, opStemFromSame } from "../../../functions/cart/CartIcon"

    export let copyCartOperation = false
    export let moveFromCartToCart = false
    export let operation: Operation | OperationOut
    export let show: boolean = false
    export let cartId = ""
    export let title: string = $_("cart.moveToCart")
    export let submitButtonLabel: string = $_("cart.move")
    export let cancelButtonLabel: string = $_("cart.cancel")
    let isInCart: boolean = false
    let tooltipContent = null
    let selectedCartsIDs: string[] = []
    let newCartName: string = ""
    let createdCarts: any[] = []
    let dispatcher = createEventDispatcher()

    if (!$carts) {
        $carts = []
    }
    async function getFullOperation(op: Operation | OperationOut) {
        const result = await getOperation("operation", { _id: op.id }, 1, 0, "full")
        if (result) {
            return result.data[0]
        }
    }

    const assignToCart = async () => {
        let fullOp: Operation
        if ("refNumber" in operation && !!operation.refNumber) {
            fullOp = await getOriginOffer(operation)
        } else {
            fullOp = (await getFullOperation(operation)) as Operation
        }
        if (!fullOp) return

        if ("refNumber" in operation && !!operation.refNumber) {
            if ($carts) {
                for (const cart of $carts) {
                    for (const cartOp of cart.operations) {
                        if (
                            cartOp?.id == fullOp?.id &&
                            cartOp?.id &&
                            cartOp?.operationOutOfferReference?.number !== operation.number
                        ) {
                            cart.operations = await deleteOperationFromCart(cartOp, cart)
                        }
                    }
                }
            }
        } else {
            if ($carts) {
                for (const cart of $carts) {
                    for (const cartOp of cart.operations) {
                        if (cartOp?.id == fullOp?.id && cartOp?.id && cartOp?.operationOutOfferReference?.number) {
                            cart.operations = await deleteOperationFromCart(cartOp, cart)
                        }
                    }
                }
            }
        }
        if ("refNumber" in operation && !!operation.refNumber) {
            fullOp.operationOutOfferObj = operation
        }
        if (fullOp) {
            fullOp.positions = fullOp.positions
                .map((pos: BaseOperationPosition) => {
                    if (!pos) return pos
                    let tmpPos = operation.positions.find((p) => p.number === pos.number)

                    tmpPos = tmpPos || pos
                    pos.orderQuantity = isNaN(tmpPos?.orderQuantity) ? tmpPos?.quantity : tmpPos?.orderQuantity
                    return pos
                })
                .filter(Boolean)
            if (!selectedCartsIDs.length && newCartName !== "") {
                let newCart = await addOperationToNewCart(null)

                selectedCartsIDs = [newCart?.id]
                $carts = [...$carts, newCart]
                addOperationToCart(fullOp, newCart)
            } else {
                if (newCartName !== "") {
                    let newCart = await addOperationToNewCart(null)
                    selectedCartsIDs = [...selectedCartsIDs, newCart.id]
                    $carts = [...$carts, newCart]
                }
                for (let i = 0; i < createdCarts.length; i++) {
                    let c = createdCarts[i]
                    if (selectedCartsIDs.includes(c.id)) {
                        let newCart = await addOperationToNewCart(c)
                        selectedCartsIDs = [...selectedCartsIDs, newCart.id]
                        $carts = [...$carts, newCart]
                    }
                }
                $carts = $carts?.map((cart) => {
                    if (selectedCartsIDs.includes(cart.id)) {
                        // Is already in cart
                        if (isOperationInCart(fullOp, cart)) {
                            // Cart is selected and operation is already in cart. >>> Doing nothing.
                            updateOperationPositionsInCart(fullOp, cart)
                        } else {
                            // Cart is selected and operation is NOT in cart. >>> Adding operation to cart.
                            addOperationToCart(fullOp, cart)
                        }
                    } else {
                        if (
                            isOperationInCart(fullOp, cart) &&
                            !copyCartOperation &&
                            (cart.id == cartId || cartId == "")
                        ) {
                            // Cart is NOT selected but operation is already in cart. >>> Deleting operation from cart.
                            deleteOperationFromCart(fullOp, cart)
                        } else {
                            // Cart is NOT selected but operation is NOT in cart. >>> Doing nothing.
                        }
                    }
                    return cart
                })
            }
        }
        if (moveFromCartToCart && cartId) {
            deleteOperationFromCart(
                fullOp,
                $carts?.find((cart) => cart?.id == cartId)
            )
        }
        show = false
    }

    const deleteOperationFromCart = async (operation: Operation, cart: Cart) => {
        cart.operations = cart.operations.filter((op) => {
            return op.id !== operation.id
        })
        await updateCartApi(cart)
        return cart.operations
    }

    const addOperationToCart = (op: Operation, cart: Cart) => {
        cart.operations.push(op)
        updateCartApi(cart)
        return cart
    }
    const updateOperationPositionsInCart = (op: Operation, cart: Cart) => {
        cart.operations.forEach((oper) => {
            if (op.id == oper.id) {
                oper.positions = op.positions
                // update also ref
                oper.operationOutOfferObj = op.operationOutOfferObj
                oper.operationOutOfferReference = op.operationOutOfferReference
            }
        })
        updateCartApi(cart)

        return cart
    }
    const updateCartApi = async (cart: Cart) => {
        await updateCart(cart)
            .then((response) => {
                cart = response.data

                newNotification({
                    class: "success",
                    html: $_("cart.updated", { values: { name: cart.name } }),
                })
                dispatcher("update")
            })
            .catch((e) => {
                newNotification({
                    class: "error",
                    html: $_("cart.updateFailedS", { values: { name: cart.name } }),
                })
            })
    }

    const addOperationToCartMemory = () => {
        if (newCartName.trim() === "") return
        let id = Math.random().toString(36)
        createdCarts.push({
            id: id,
            name: newCartName,
            ident: $login?.account?.ident,
            operations: [],
            deliveryAddressIsHomeAddress: true,
        })
        newCartName = ""
        createdCarts = createdCarts
        selectedCartsIDs = [...selectedCartsIDs, id]
    }

    const addOperationToNewCart = async (inputCart: { id: any } | null) => {
        if (newCartName === "" && !inputCart) return
        if (inputCart) {
            delete inputCart.id
        }
        try {
            const response = await createCart(
                // @ts-ignore
                inputCart || {
                    name: newCartName,
                    ident: $login?.account?.ident,
                    operations: [],
                    deliveryAddressIsHomeAddress: true,
                }
            )

            let newCart = response.data

            newNotification({
                class: "success",
                html: $_("cart.created", { values: { name: newCart.name } }),
            })
            dispatcher("update")
            return newCart
        } catch (e) {
            newNotification({
                class: "error",
                html: $_("cart.createFailed", { values: { name: newCartName } }),
            })
        }
    }

    const toggleCart = (cart: { id: string }) => {
        if (selectedCartsIDs.includes(cart.id)) {
            selectedCartsIDs = selectedCartsIDs.filter((id) => id !== cart.id)
        } else {
            selectedCartsIDs.push(cart.id)
        }
        selectedCartsIDs = selectedCartsIDs
    }

    const switchCart = (cart: { id: string }) => {
        if (selectedCartsIDs.includes(cart.id)) selectedCartsIDs = []
        else selectedCartsIDs = [cart.id]
    }

    const isOperationInCart = (operation: Operation, cart: Cart) => {
        for (let op of cart.operations) {
            if (op.id === operation.id) {
                return true
            }
        }
        return false
    }

    const isAssignedInAnyCart = () => {
        if (moveFromCartToCart) {
            selectedCartsIDs.push(cartId)
            selectedCartsIDs = selectedCartsIDs
            return [$carts.find((cart) => cart.id == cartId)]
        }
        selectedCartsIDs = []
        let foundInCarts: Cart[] = []
        if ($carts && $carts.length) {
            for (let cart of $carts) {
                for (let op of cart.operations) {
                    if (opStemFromSame(operation, op)) {
                        selectedCartsIDs.push(cart?.id)
                        foundInCarts.push(cart)
                    }
                }
            }
        }

        return foundInCarts
    }

    $: if (operation || $carts) {
        const foundInCarts: Cart[] = isAssignedInAnyCart()
        isInCart = foundInCarts.length > 0

        if (isInCart) {
            tooltipContent = $_("cart.inCartTooltip") + foundInCarts.map((cart) => cart?.name).join("<br/>")
        } else {
            tooltipContent = $_("cart.addToCartTooltip")
        }
    }
    $: {
        if (moveFromCartToCart) {
            if (selectedCartsIDs.length > 1) {
                selectedCartsIDs = [selectedCartsIDs[selectedCartsIDs.length - 1]]
            }
        }
    }

    function reset() {
        newCartName = ""
        createdCarts = []
        selectedCartsIDs = []
    }
    $: {
        if (!show) reset()
    }
    let validCartname = false
    $: {
        validCartname =
            newCartName.trim() !== "" &&
            [...createdCarts, ...$carts].find((cart) => cart.name === newCartName) === undefined
    }
</script>

{#if show}
    <Modal {show} cssClass="assign-operation-to-cart" on:close="{() => (show = false)}" showCloseIcon="{false}">
        <div slot="header">{@html title}</div>

        <div class="table">
            <div class="tablerow trow no-hover new-cart-input-row">
                <div class="col w-auto">
                    <EditField
                        bind:value="{newCartName}"
                        label="{$_('cart.assignOperation.newCartLabel')}"
                        noIcon="{true}"
                        on:enter="{addOperationToCartMemory}"
                    />
                </div>
                <div class="col w-60">
                    <button
                        class="add-to-new-cart btn btn-link"
                        data-cy="add-to-new-cart"
                        use:tooltip="{{
                            content: $_('cart.assignOperation.tooltipAddToCart'),
                        }}"
                        disabled="{!validCartname}"
                        on:click="{addOperationToCartMemory}"
                        on:keydown
                    >
                        <Icon size="30px" path="{mdiPlusCircleOutline}" />
                    </button>
                </div>
            </div>

            {#each [...(createdCarts || []), ...($carts || [])] as cart}
                {#if moveFromCartToCart}
                    <!-- svelte-ignore a11y-no-static-element-interactions -->
                    <div class="tablerow trow" on:click="{() => switchCart(cart)}" on:keydown>
                        <div class="col w-auto alignleft">{cart.name}</div>
                        <div class="col w-60 vcenter aligncenter">
                            <Radiobutton
                                checked="{selectedCartsIDs.includes(cart.id)}"
                                on:checked="{() => switchCart(cart)}"
                                on:unchecked="{() => switchCart(cart)}"
                            />
                        </div>
                    </div>
                {:else}
                    <!-- svelte-ignore a11y-no-static-element-interactions -->
                    <div class="tablerow trow" on:click="{() => toggleCart(cart)}" on:keydown>
                        <div class="col w-auto alignleft">{cart.name}</div>
                        <div class="col w-60 vcenter aligncenter">
                            <Checkbox
                                checked="{selectedCartsIDs.includes(cart.id)}"
                                on:checked="{() => toggleCart(cart)}"
                                on:unchecked="{() => toggleCart(cart)}"
                            />
                        </div>
                    </div>
                {/if}
            {/each}
        </div>

        <div slot="footer">
            <button class="btn btn-secondary" on:click|stopPropagation="{() => (show = false)}"
                >{cancelButtonLabel}</button
            >
            {#key [validCartname, $carts, createdCarts, newCartName, selectedCartsIDs]}
                <div
                    use:tooltip="{{
                        content: !(
                            (!$carts?.length && !createdCarts?.length && newCartName.trim() == '') ||
                            (!validCartname && newCartName.trim() !== '') ||
                            (!selectedCartsIDs.length && !validCartname)
                        )
                            ? $_('cart.assignOperation.tooltipAddToCart')
                            : !validCartname
                              ? $_('cart.assignOperation.invalidCartNameTooltip')
                              : !$carts?.length && !createdCarts?.length && newCartName.trim() == ''
                                ? $_('cart.assignOperation.noCartNameTooltip')
                                : $_('cart.assignOperation.selectCartTooltip'),
                    }}"
                >
                    <button
                        class="btn"
                        on:click="{assignToCart}"
                        disabled="{(!$carts?.length && !createdCarts?.length && newCartName.trim() == '') ||
                            (!validCartname && newCartName.trim() !== '') ||
                            (!selectedCartsIDs.length && !validCartname)}"
                        >{submitButtonLabel}
                    </button>
                </div>{/key}
        </div>
    </Modal>
{/if}
